<template>
  <section class="mb-4">
    <section-title id="infos">
      {{ $t("contact-info-title") }}
    </section-title>
    <b-card v-if="client.firstName" class="mb-3 shadow">
      <div class="row">
        <div class="col-md-4">
          {{ client.address }} <br />
          {{ client.zipCode }}, {{ client.city }}
        </div>
      </div>
      <!-- <div slot="footer">
          <b-btn variant="primary" size="sm">
            <svgicon icon="pencil" color="#DA83B1" class="mr-1"></svgicon>
            Modifier mes coordonnées
          </b-btn>
        </div> -->
    </b-card>

    <b-card v-else class="mb-3 shadow">
      {{ $t("no-data") }}
    </b-card>
  </section>
</template>

<script>
import SectionTitle from "../../../SectionTitle.vue";
import ClientService from "../../../../services/client";
import { mapActions } from "vuex";

export default {
  components: {
    SectionTitle
  },
  data() {
    return {
      client: {}
    };
  },
  created() {
    this.load();
  },
  methods: {
    ...mapActions("auth", ["handleAxiosErrors"]),
    load() {
      this.getClientCoordonnees();
    },
    getClientCoordonnees() {
      ClientService.get()
        .then(response => {
          // var resultat = JSON.parse(response.data);
          this.client = response.data;
          this.$emit("readyAdressBlock", true);
        })
        .catch(error => {
          // handle error
          this.handleAxiosErrors(error);
        });
    }
  }
};
</script>

<style></style>
